import { Component, ElementRef, Inject, ViewChild, AfterViewInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { JApiService} from '@j/api';
import { LanguageService } from '@hio/language';
import { JcRaisedButtonDirective } from '@jc/button';
import { JcButtonDirective } from '../../../jc-button/src/lib/jc-button.directive';
import { ensureShareBasicI18n } from './share-basic-i18n';

@Component({
    selector: 'dialog-delete',
    styles: [
        `

        `
    ],
    template: `
<div>
    <h2 mat-dialog-title> {{ title }}

    </h2>
    <hr>
    <mat-dialog-content style="display: flex">
        {{ text }}
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions>
        <button color="primary" jcButton tabindex="2" (click)="onCancel()">{{ lang.t('shareBasic.cancel') }}</button>
        <div class="spacer"></div>
        <button color="warn" jcRaisedButton tabindex="1" #delButton (click)="onDelete()">{{ lang.t('shareBasic.delete') }}</button>
    </mat-dialog-actions>
</div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogModule, JcButtonDirective, JcRaisedButtonDirective]
})

export class DialogDeleteComponent implements AfterViewInit {
    @ViewChild('delButton') delbtn: ElementRef;
    lang = ensureShareBasicI18n(inject(LanguageService));
    public title = this.lang.t('shareBasic.deleteTitle');
    public text = this.lang.t('shareBasic.deleteText');


    constructor(public dialogRef: MatDialogRef<DialogDeleteComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { title: string, text: string, onDelete: Function, onCancel: Function },
                public api: JApiService) {
        dialogRef.disableClose = true;
        if (data.text)
            this.text = data.text;
        if (data.title)
            this.title = data.title;
    }

    public onCancel() {
        if (this.data.onCancel) this.data.onCancel();
        this.dialogRef.close();
    }

    public onDelete() {
        console.log('DELETE');
        this.data.onDelete();
        this.dialogRef.close();
    }

    public ngAfterViewInit() {

    }

}
